module.exports = __webpack_public_path__ + "img/wave-pulse.0f078f88.svg";